import { fg } from '@atlaskit/platform-feature-flags';

import { type ChatStoreContainerProps } from '../types';

type MinionVerificationItem = {
	alias: string;
	minionId: string;
};

export const AI_MATE_AGENT_ID = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156'; // This is the agent id for Solution Architect Agent, which is currently the only agent that has minion verification implemented. We will allow the minion verification for this agennt

const possible_agents = [AI_MATE_AGENT_ID, 'ai_mate_agent'];

const MINION_VERIFICATION_ITEMS: MinionVerificationItem[] = [
	{
		alias: 'design-solution',
		minionId: 'SolutionArchitectMinion',
	},
	{
		alias: 'rovo-agent-builder',
		minionId: 'AgentBuilderMinion',
	},
	{
		alias: 'build-automation',
		minionId: 'AutomationWorkflowBuilderMinion',
	},
];

type MinionVerificationAnalyticsProps = {
	minionAlias?: string;
	agentId?: string;
	minionsOutput: { minion_id: string }[];
	sendAnalyticsEvent: ChatStoreContainerProps['sendAnalyticsEvent'];
};

export const minionVerificationAnalytics = ({
	minionAlias,
	agentId,
	minionsOutput,
	sendAnalyticsEvent,
}: MinionVerificationAnalyticsProps): void => {
	if (!minionAlias) { return; }
	if (agentId && !possible_agents.includes(agentId) && fg('fix_minion_verification_event')) { return; }

	MINION_VERIFICATION_ITEMS.forEach(({ alias, minionId }) => {
		if (alias !== minionAlias) { return; }

		const hasAliasMatch = minionsOutput.some((output) => output.minion_id === minionId);

		sendAnalyticsEvent({
			eventType: 'track',
			action: hasAliasMatch ? 'matched' : 'mismatched',
			actionSubject: 'aiMateMinionVerification',
			attributes: {
				name: minionId,
			},
		});
	});
};
